import { render } from "./UserMain.vue?vue&type=template&id=705c473f&scoped=true"
import script from "./UserMain.vue?vue&type=script&lang=js"
export * from "./UserMain.vue?vue&type=script&lang=js"

import "./UserMain.vue?vue&type=style&index=0&id=705c473f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705c473f"]])

export default __exports__